// Sistema padronizado de cores para desvios em todo o dashboard

export interface DeviationColorConfig {
  className: string;
  bgColor: string;
  textColor: string;
}

export const getDeviationColor = (deviation: number): DeviationColorConfig => {
  const absDeviation = Math.abs(deviation);
  
  if (absDeviation < 1) {
    return {
      className: 'badge-success',
      bgColor: '#10B981', // green-500
      textColor: '#FFFFFF'
    };
  } else if (absDeviation <= 5) {
    return {
      className: 'badge-warning', 
      bgColor: '#F59E0B', // amber-500
      textColor: '#FFFFFF'
    };
  } else {
    return {
      className: 'badge-danger',
      bgColor: '#EF4444', // red-500
      textColor: '#FFFFFF'
    };
  }
};

export const getDeviationBadgeClass = (deviation: number): string => {
  return getDeviationColor(deviation).className;
};

export const formatDeviation = (deviation: number): string => {
  return `${deviation > 0 ? '+' : ''}${deviation.toFixed(2)}%`;
};

// Sistema padronizado de cores para crescimento/performance
export const getGrowthColorClass = (value: number): string => {
  return value >= 0 ? 'text-success-600' : 'text-danger-600';
};

export const getGrowthIconColorClass = (value: number): string => {
  return value >= 0 ? 'text-success-600' : 'text-danger-600';
};
